<template>
  <bcc-dialog :visible="show" top='10vh' width="500px" @close="handleCompanyDialog(false)">
    <!-- 状态(0待接收;1已接受;2已拒绝;3已撤销) -->
      <h3>{{ isManager ? '管理员授权' : '开发者授权' }}</h3>
      <p v-if='data.state === 0' class="des">24小时内该授权有效，若超时未接受则默认拒绝邀请；接受该授权后，你将无法成为其他机构的管理员/开发者'</p>
      <div class="auth-group">
        <span>授权权限:</span>  
        <bcc-checkbox-group v-if='isManager' class="check-box" disabled v-model="limits">
          <bcc-checkbox label="企业信息编辑权限"></bcc-checkbox>
          <bcc-checkbox label="申请应用权限"></bcc-checkbox>
          <bcc-checkbox label="应用管理权限"></bcc-checkbox>
          <bcc-checkbox label="授权开发者权限"></bcc-checkbox>
          <bcc-checkbox label="邀请管理员权限"></bcc-checkbox>
        </bcc-checkbox-group>
        <bcc-checkbox-group v-if='isDeveloper' class="check-box" disabled v-model="data.app_names">
          <div class="app-list-box">
            <bcc-checkbox falseValue="" v-for="(item, idx) in data.app_names" :key="idx" :label="item">{{item}}</bcc-checkbox>
          </div>
        </bcc-checkbox-group>
      </div>
      <div slot="footer">
        <template v-if='data.state === 0'>
          <bcc-button @click="handleOperate(1)" size="middle" type="primary">接受</bcc-button>
          <bcc-button style="margin-left:20px" @click="handleOperate(0)" size="middle" type="primary">拒绝</bcc-button>
        </template>
        <bcc-button v-else @click="show = false" size="middle" type="primary">关闭</bcc-button>
      </div>
  </bcc-dialog>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      data: {},
      limits: [
        '企业信息编辑权限',
        '申请应用权限',
        '应用管理权限',
        '授权开发者权限',
        '邀请管理员权限'
      ]
    }
  },
  computed: {
    isManager () {
      return this.data.level === 20
    },
    isDeveloper () {
      return this.data.level === 30
    },
    getRejectTxt () {
      return this.data.state === 2 ? '拒绝' : '撤销'
    }
  },
  methods: {
    handleCompanyDialog () {
      this.show = false
    },
    async handleOperate (type) {
      if (type === 0) { // 拒绝
        this.$api.auth.handleRefuse({
          id: this.data.id
        }).then(() => {
          this.$message({
            content: '操作成功',
            type: 'success',
            offset: 60,
            duration: 1500
          })
          this.show = false
          this.$emit('refreshData')
        }).catch((e) => {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        })
      } else {
        this.$api.auth.handleAccept({
          id: this.data.id
        }).then(() => {
          this.$message({
            content: '操作成功',
            type: 'success',
            offset: 60,
            duration: 1500
          })
          this.$emit('refreshData')
          this.$store.dispatch('getUserInfo')
          this.show = false
        }).catch((e) => {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.des {
  margin-top: 30px;
}
.auth-group {
  margin-left: 40px;
  display: flex;
  margin-top: 30px;
}
.check-box {
    flex-direction: column;
    margin-left: 20px;
    margin-top: -9px;
    .bcc-checkbox {
      margin-left: 0;
      margin-top: 15px;
      &:first-child {
        margin-top: 10px;
      }
      ::v-deep .bcc-checkbox-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 300px;
      }
    }
  }
</style>
